import { createFileRoute } from "@tanstack/react-router";
import { Breadcrumbs, TrashView } from "../../components/media";
import { MediaType } from "../../generated/graphql";
import { useAppSelector } from "../../store";

export const Route = createFileRoute("/media/videos/trash")({
  component: VideosTrashPage,
});

function VideosTrashPage() {
  const selectedFolderId = useAppSelector((state) => state.media.selectedFolderId);

  return (
    <div className="space-y-6 lg:p-[1%]">
      {/* Breadcrumbs */}
      <Breadcrumbs
        currentFolderId={selectedFolderId}
        mediaType={MediaType.Video}
        rootLabel="Videos"
        showTrash={true}
      />

      {/* Trash View */}
      <TrashView folderId={selectedFolderId} mediaType={MediaType.Video} />
    </div>
  );
}
